import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "svg14",
	viewBox: "0 0 24 24",
	height: 24,
	width: 24,
	...props,
	children: [/* @__PURE__ */ _jsx("metadata", { id: "metadata20" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			strokeWidth: 1,
			stroke: "#bebebe",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("circle", {
				fill: "none",
				r: 11.5,
				cy: 12,
				cx: 12
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 7,
			x: 7,
			height: 8,
			width: 8,
			style: {
				fill: "#ffffff",
				stroke: "#00488E",
				strokeOpacity: 1
			}
		}),
		/* @__PURE__ */ _jsx("rect", {
			style: {
				fill: "#ffffff",
				stroke: "#00488E",
				strokeOpacity: 1
			},
			width: 8,
			height: 8,
			x: 9.5,
			y: 9.5
		})
	] })]
});
export default SvgDuplicate;
